import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { Tab } from '@headlessui/react';
import Modal from '../../components/Modal/Modal';
import FormTextInput from '../../components/Form/FormTextInput';

const AssignPerformanceDataModal = ({
                                         open, onClose, editFunction, editIndex, defaultValue
                                     }) => {
    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const [formikInitialValues, setFormikInitialValues] = useState({
        tVisible: '',
        visOut: '',
        uValueWinterImperial: '',
        uValueWinterMetric: '',
        uValueSummerImperial: '',
        uValueSummerMetric: '',
        sc: '',
        shgc: '',
        lsg: '',
    });

    // TODO validation looks like not necessary for now
    const validationSchema = Yup.object().shape({
        drawingName: Yup.string(),
        tVisible: Yup.string(),
        visOut: Yup.string(),
        uValueWinterImperial: Yup.string(),
        uValueWinterMetric: Yup.string(),
        uValueSummerImperial: Yup.string(),
        uValueSummerMetric: Yup.string(),
        sc: Yup.string(),
        shgc: Yup.string(),
        lsg: Yup.string(),
    });

    useEffect(() => {
        setFormikInitialValues({
            tVisible: defaultValue.description_visible,
            visOut: defaultValue.reflectance_out,
            uValueWinterImperial: defaultValue.u_value_solar,
            uValueWinterMetric: defaultValue.u_value_solar,
            uValueSummerImperial: defaultValue.u_value_summer,
            uValueSummerMetric: defaultValue.u_value_summer,
            sc: defaultValue.shading_coefficient,
            shgc: defaultValue.solar_heat_gain_coefficient,
            lsg: defaultValue.light_solar_gain_ration,
        });
    }, [defaultValue]);

    const onSubmitHandler = async (formData) => {
        try {
            editFunction(editIndex, formData);
            onCloseButtonClickHandler();
            toast.success('Success');
        } catch {
            toast.error('Something went wrong. Please try again');
        }
    };

    return (
        <Modal open={open} setOpen={onCloseButtonClickHandler}>
            <div className="px-2">
                <Tab.Group>
                    <Tab.Panels>
                        <Formik
                            enableReinitialize
                            initialValues={formikInitialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmitHandler}
                        >
                            {({ errors }) => (
                                <Form className="flex flex-col gap-2 py-4">
                                    <div className="flex flex-row w-full">
                                        <div className="flex flex-col w-full px-2">
                                            <FormTextInput name="tVisible" label='Visible Transmission Visible (VLT)' />
                                            <FormTextInput name="visOut" label='Visible Light-Exterior Reflectance (R Out)' />
                                            <FormTextInput name="uValueWinterImperial" label='Winter U-Value' />
                                            <FormTextInput name="uValueSummerImperial" label='Summer U-Value' />
                                            <FormTextInput name="sc" label='Shading Coefficient (SC)' />
                                            <FormTextInput name="shgc" label='Solar Heat Gain Coefficient (SGHC)' />
                                            <FormTextInput name="lsg" label='Light to Solar Gain Ratio (LSG)' />
                                        </div>
                                    </div>
                                    <button
                                        // isBlock
                                        // disabled={Object.keys(errors).length > 0 || isLoading}
                                        type="submit"
                                        // isLoading={isLoading}
                                    >
                                        Update
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </Tab.Panels>
                </Tab.Group>
            </div>
        </Modal>
    );
};

AssignPerformanceDataModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    editFunction: PropTypes.func.isRequired,
    defaultValue: PropTypes.object.isRequired,
    editIndex: PropTypes.number.isRequired,
};

export default AssignPerformanceDataModal;
